<template>
  <v-col align="center">
    <v-row justify="center" style="width: 100%">
      <!-- Button to upload image -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            rounded
            outlined
            color="primary"
            class="mx-2 mt-2"
            :disabled="disabled"
            @click="pickFile"
          >
            <v-icon>add_a_photo</v-icon>
          </v-btn>
        </template>
        <span>{{ imageTooltip }}</span>
      </v-tooltip>

      <!-- Button to delete image -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            rounded
            outlined
            color="red accent-3"
            class="mx-2 mt-2"
            :class="hasImage ? '' : 'd-none'"
            :disabled="disabled"
            @click="onDeleteImage"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
        <span>{{ $translate('DELETE') }}</span>
      </v-tooltip>
    </v-row>

    <div :class="hasImage ? '' : 'd-none'" class="mt-4">
      <v-img
        :ref="imgId"
        contain
        :src="imageProps.src"
        height="100"
        :max-width="viewMaxWidth"
      ></v-img>
    </div>

    <input
      type="file"
      style="display: none"
      :ref="loaderId"
      accept="image/*"
      cancelable="true"
      multiple="false"
      cancelBubble="true"
      @change="enableCropper"
    />

    <!-- crop dialog -->
    <v-dialog v-model="cropDialog" width="80%">
      <ImageCropper
        :file="file"
        :multiple="false"
        :aspectRatio="aspectRatio"
        :overlayText="overlayText"
        @imageCropped="cropImage"
      >
      </ImageCropper>
    </v-dialog>

    <v-dialog max-width="400" max-height="500" v-model="activateRatioDialog">
      <v-card>
        <v-card-title>
          {{ $translate('IMAGE_SIZE_NOT_REGULAR') }}
        </v-card-title>
        <v-card-text style="color: black" class="pa-5">
          {{ $translate('IMAGE_SIZE_NOT_REGULAR_SAVE') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="activateRatioDialog = false" color="primary">
            {{ $translate('CONTINUE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import ImageCropper from '@/components/generalComponents/media/ImageCropper';
import appConfig from '../../../../config/app_config';

export default {
  name: 'ImageLoader',
  components: {
    ImageCropper,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    overlayText: String,
    aspectRatio: {
      type: Number,
      default: 1.618 / 1,
    },
    imageProps: Object,
  },
  computed: {
    viewMaxWidth() {
      if (this.aspectRatio != null && this.aspectRatio >= 1) {
        return 100 * this.aspectRatio;
      }
      return undefined;
    },
  },
  watch: {
    cropDialog(newV) {
      if (!newV) {
        this.$refs[this.loaderId].value = null;
      }
    },
    imageProps() {
      this.handlePropsChange();
    },
  },
  data() {
    return {
      activateRatioDialog: false,
      hasImage: false,
      image: new Image(),
      imageTooltip: this.$translate('UPLOAD_AN_IMAGE'),
      imgId: '',
      loaderId: 'imgLoader',

      cropDialog: false,
      cropImg: '',
      file: null,
      filename: '',
    };
  },
  created() {},
  mounted() {
    this.handlePropsChange();
  },
  methods: {
    cropImage(crop, newName) {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = crop;
      this.filename = newName;
      this.onImageFilePicked();
    },
    enableCropper(a) {
      this.file = a.target.files[0];
      this.filename = this.file.name;
      if (this.filename.length > this.maxNameLength) {
        this.filename = this.filename.substr(0, this.maxNameLength);
      }
      if (this.file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      this.cropDialog = true;
    },
    handlePropsChange() {
      if (this.imageProps.src != null && this.imageProps.src !== '') {
        this.image.src = this.imageProps.src;
        this.hasImage = true;
      } else {
        this.image.src = '';
        this.hasImage = false;
      }
      if (this.imageProps.id != null) {
        this.loaderId = this.imageProps.id;
        this.imgId = `${this.loaderId}_img`;
      }
    },
    pickFile() {
      this.$refs[this.loaderId].click();
    },
    onImageFilePicked() {
      this.cropDialog = false;

      if (this.file != null) {
        const fr = new FileReader();
        fr.readAsDataURL(this.file);
        fr.addEventListener('error', () => {});
        fr.addEventListener('load', () => {
          // clean first
          this.image.src = '';
          this.hasImage = false;

          // reload the image
          this.image.src = this.cropImg;
          this.hasImage = true;
          this.image.onload = () => {
            const imgWidth = this.image.naturalWidth;
            const imgHeight = this.image.naturalHeight;
            const ratioNr = imgWidth / imgHeight;
            if (ratioNr < 0.75 || ratioNr > 1.75) {
              this.activateRatioDialog = true;
            }
          };
          if (!this.activateRatioDialog) {
            this.$emit('uploadImage', this.image.src);
          }
        });
      }
    },
    onDeleteImage() {
      this.hasImage = false;
      this.image.src = '';
      this.file = null;
      this.filename = '';
      this.$emit('uploadImage', '');
    },
  },
};
</script>

<style scope>
#fileInput {
  display: none;
}
.delete-btn {
  position: absolute;
  top: 4px;
  right: 0px;
}
</style>
